var StateHelperProvider = (function () {
    function StateHelperProvider(stateHelperProvider, $urlRouterProvider) {
        this.stateHelperProvider = stateHelperProvider;
        this.$urlRouterProvider = $urlRouterProvider;
        $urlRouterProvider.otherwise('/404');
        stateHelperProvider
            .state({
            authenticate: false,
            children: [],
            name: 'home',
            template: '<home-section/>',
            url: '/'
        })
            .state({
            authenticate: true,
            name: 'subtest-view',
            template: '<subtest-view-section/>',
            url: '/subtest-view'
        })
            .state({
            authenticate: true,
            name: 'queue',
            template: '<queue-section/>',
            url: '/queue/:id'
        })
            .state({
            authenticate: true,
            name: 'landing',
            template: '<landing-section/>',
            url: '/landing-page'
        })
            .state({
            authenticate: true,
            name: 'queueSampling',
            template: '<queue-sampling-section/>',
            url: '/queue-sampling'
        })
            .state({
            authenticate: true,
            name: 'queueError',
            template: '<queue-error-section/>',
            url: '/queue-error'
        })
            .state({
            authenticate: true,
            name: 'queueErrorGeneral',
            template: '<queue-error-gen-section/>',
            url: '/queue-error_general'
        }).
            state({
            authenticate: true,
            name: 'queueSapMissing',
            template: '<queue-sap-missing-section/>',
            url: '/queue-sap-missing'
        })
            .state({
            authenticate: true,
            name: 'queueSetAside',
            template: '<queue-setaside-section/>',
            url: '/queue-setaside'
        })
            .state({
            authenticate: true,
            name: 'approvals',
            template: '<approvals-section/>',
            url: '/approvals'
        })
            .state({
            authenticate: true,
            children: [
                {
                    authenticate: true,
                    name: 'general',
                    template: '<detail-general/>',
                    url: '/general'
                },
                {
                    authenticate: true,
                    name: 'eligibility',
                    template: '<detail-eligibility/>',
                    url: '/eligibility'
                }, {
                    authenticate: true,
                    name: 'payment',
                    template: '<payment-gate/>',
                    url: '/payment'
                }, {
                    authenticate: true,
                    name: 'sampling',
                    template: '<detail-sampling/>',
                    url: '/sampling'
                }, {
                    name: 'validation',
                    url: '/validation',
                    template: '<detail-validation/>',
                    authenticate: true
                }, {
                    name: 'searchsubmit',
                    url: '/searchsubmit',
                    template: '<search-submit-section/>',
                    authenticate: true
                }],
            name: 'detail',
            template: '<detail-section/>',
            url: '/detail/:id'
        })
            .state({
            authenticate: true,
            name: 'preview',
            template: '<preview-section/>',
            url: '/preview/:id'
        })
            .state({
            authenticate: true,
            name: 'team',
            template: '<team-view/>',
            url: '/team/:id'
        })
            .state({
            authenticate: true,
            name: 'reporting',
            template: '<reporting-section/>',
            url: '/reporting'
        })
            .state({
            authenticate: true,
            name: 'help',
            template: '<help-section/>',
            url: '/help'
        })
            .state({
            authenticate: false,
            children: [],
            name: 'about',
            template: '<about-section/>',
            url: '/about'
        })
            .state({
            authenticate: true,
            children: [
                {
                    authenticate: true,
                    name: 'main',
                    template: '<admin-main-section/>',
                    url: '/main'
                },
                {
                    authenticate: true,
                    name: 'termsofuse-view',
                    template: '<view-terms-section/>',
                    url: '/termsofuse-view'
                },
                {
                    authenticate: true,
                    name: 'checklist-view',
                    template: '<view-check-list-section/>',
                    url: '/checklist-view'
                },
                {
                    authenticate: true,
                    name: 'checklist-update',
                    template: '<admin-check-list-section/>',
                    url: '/checklist-update/:sl'
                },
                {
                    authenticate: true,
                    name: 'checklist-edit',
                    template: '<admin-check-list-section/>',
                    url: '/checklist-edit/:sl'
                },
                {
                    authenticate: true,
                    name: 'misc-codes-view',
                    template: '<view-misc-codes-section/>',
                    url: '/misc-codes-view'
                },
                // {
                //     authenticate: true,
                //     name: 'gbt20-view',
                //     template: '<view-gbt20-section/>',
                //     url: '/gbt20-view',
                // },
                {
                    authenticate: true,
                    name: 'mysa-dmt-view',
                    template: '<view-mysa-dmt-section/>',
                    url: '/mysa-dmt-view'
                },
                {
                    authenticate: true,
                    name: 'mysa-im-outbound-view',
                    template: '<view-mysa-im-outbound-section/>',
                    url: '/mysa-im-outbound-view'
                },
                {
                    authenticate: true,
                    name: 'gppload-view',
                    template: '<view-gppload-section/>',
                    url: '/gppload-view'
                },
                {
                    authenticate: true,
                    name: 'columns-view',
                    template: '<view-columns-section/>',
                    url: '/columns-view'
                },
                {
                    authenticate: true,
                    name: 'columns',
                    template: '<admin-columns-section/>',
                    url: '/columns/:id'
                },
                {
                    authenticate: true,
                    name: 'program-view',
                    template: '<view-program-section/>',
                    url: '/program-view'
                },
                {
                    authenticate: true,
                    name: 'program',
                    template: '<admin-program-section/>',
                    url: '/program/:id'
                },
                {
                    authenticate: true,
                    name: 'sampling-view',
                    template: '<view-sampling-section/>',
                    url: '/sampling-view'
                },
                {
                    authenticate: true,
                    name: 'bpoiswitches-view',
                    template: '<view-bpoiswitch-section/>',
                    url: '/bpoiswitches-view'
                },
                {
                    authenticate: true,
                    name: 'validation-view',
                    template: '<view-validation-section/>',
                    url: '/validation-view'
                },
                {
                    authenticate: true,
                    name: 'exchangerate-view',
                    template: '<view-exchangerate-section/>',
                    url: '/exchangerate-view'
                },
                {
                    authenticate: true,
                    name: 'country-view',
                    template: '<view-country-section/>',
                    url: '/country-view'
                },
                {
                    authenticate: true,
                    name: 'calculation-view',
                    template: '<view-calculation-section/>',
                    url: '/calculation-view'
                },
                {
                    authenticate: true,
                    name: 'adminreporting-view',
                    template: '<view-adminreporting-section/>',
                    url: '/adminreporting-view'
                },
                {
                    authenticate: true,
                    name: 'status-view',
                    template: '<view-status-section/>',
                    url: '/status-view'
                },
                {
                    authenticate: true,
                    name: 'status',
                    template: '<admin-status-section/>',
                    url: '/status/edit?status'
                },
                {
                    authenticate: true,
                    name: 'mysaerrlogs-view',
                    template: '<mysaerrlogs-section>',
                    url: '/mysa-errors-logs'
                },
                {
                    authenticate: true,
                    name: 'mysaerrlogs-details-view',
                    template: '<mysaerrlogs-details-section/>',
                    url: '/mysa-errors-logs/:id'
                },
                {
                    authenticate: true,
                    name: 'users-view',
                    template: '<view-user-section/>',
                    url: '/users-view'
                },
                {
                    authenticate: true,
                    name: 'mysaresponse-view',
                    template: '<view-mysaresponse-section/>',
                    url: '/mysaresponse-view'
                },
                {
                    authenticate: true,
                    name: 'bpmergers-view',
                    template: '<view-bpmergers-section/>',
                    url: '/bpMergers'
                },
                {
                    authenticate: true,
                    name: 'user',
                    template: '<admin-user-main-section/>',
                    url: '/user/edit?user'
                },
                {
                    authenticate: true,
                    name: 'approvedlist-view',
                    template: '<approved-list-section/>',
                    url: '/approved-list'
                },
                {
                    authenticate: true,
                    name: 'massupdates-view',
                    template: '<mass-update-section>',
                    url: '/mass-update'
                },
                {
                    authenticate: true,
                    name: 'complianceplan-view',
                    template: '<complianceplan-section>',
                    url: '/compliance-plan'
                },
                {
                    authenticate: true,
                    name: 'eslogs-view',
                    template: '<eslogs-section>',
                    url: '/es-logs'
                },
                {
                    authenticate: true,
                    name: 'eslogs-details-view',
                    template: '<eslogs-details-section/>',
                    url: '/es-logs/:id'
                },
            ],
            name: 'admin',
            template: '<admin-section/>',
            url: '/admin/main'
        })
            .state({
            authenticate: true,
            name: 'download',
            template: '',
            url: '/download/:id/:name'
        })
            .state({
            authenticate: true,
            name: 'excel-export',
            template: '',
            url: '/excel-export/:id/:comp/:timestamp'
        })
            .state({
            authenticate: true,
            name: 'user-profile',
            template: '<user-profile-section/>',
            url: '/user-profile'
        })
            .state({
            authenticate: true,
            name: 'loading',
            template: '<loading-view/>',
            url: '/loading/:id'
        })
            .state({
            authenticate: false,
            children: [],
            name: '404',
            templateUrl: '404.html',
            url: '/404'
        })
            .state({
            authenticate: false,
            children: [],
            name: '403',
            templateUrl: '403.html',
            url: '/403'
        })
            .state({
            children: [],
            name: '500',
            notauth: true,
            template: '<not-auth-section>',
            url: '/500'
        })
            .state({
            children: [],
            name: 'noprofile',
            notauth: true,
            url: '/noprofile',
            templateUrl: 'noprofile.html'
        })
            .state({
            children: [],
            name: 'noadmin',
            notauth: true,
            templateUrl: 'noadmin.html',
            url: '/noadmin'
        })
            .state({
            children: [],
            name: 'terms',
            notauth: true,
            template: '<terms-section>',
            url: '/terms'
        })
            .state({
            children: [],
            name: 'noapprover',
            notauth: true,
            templateUrl: 'noapprover.html',
            url: '/noapprover'
        })
            .state({
            name: 'login',
            notauth: true,
            url: 'loginw3'
        });
    }
    StateHelperProvider.$inject = ['stateHelperProvider', '$urlRouterProvider'];
    return StateHelperProvider;
}());
angular
    .module('application')
    .config(StateHelperProvider);

//# sourceMappingURL=state.js.map
